import http from '../utils/http'

// 登录 https://h5.sqiquan.cuori.com.cn/apix/agentpc.me/login.html 返回token,是登录成功的凭证
// $user = input('?post.user )?input( 'post .user ) :
// $pwd= input('?postpwd')?input('post.pwd'): ;//pwd
export function login(params) {
    return http.post(`/apix/agentpc.me/login.html`,params);
}

// 获取 代理用户 信息接口 https://h5.sqiquan.cuori.com.cn/apix/agentpc.me/userInfo.html 
// $token = input('post.token');
export function queryUserInfo(params) {
    return http.post(`/apix/agentpc.me/userInfo.html`,params);
}


// get请求 获取股票标的列表
export function queryShares(bn){
    return http.post(`/apix/h5.shares/search.html`,bn)
}

// 获取券商列表 https://h5.sqiquan.cuori.com.cn/apix/agentpc.options/jobbers.html
export function queryJobbers(params){
    return http.post(`/apix/agentpc.options/jobbers.html`,params)
}

// 报价查询：https://h5.sqiquan.cuori.com.cn/apix/agentpc.options/search.html
// $bn = input('?post.bn')?input('post.bn'): ; // 股票代码
// $class = input('?post.class')?input('post.class'):'all'; // 区域
// $struct = input('?post.struct')?input('post.struct'):'10acall,8acall'
// $balance = input('?post.balance')?input('post.balance'):'30'; // 周期
// $jobber = input('?post.jobber')?input('post.jobber'):; // 券商
export function queryOptionsSearch(params){
    return http.post(`/apix/agentpc.options/search.html`,params)
}


// 持仓/历史 https://h5.sqiquan.cuori.com.cn/apix/agentpc.contract/list.html
// 需登录查询，搜索关键词 $keyword = input('?post.keyword')?input('post.keyword'):"";
// 分页：$page = input('?post.page')?input('post.page'):1; // 分页
// 默认10条每页
// 1,'已成交', 2, '已完成' ：status,对应持仓和历史
export function queryOrderList(params){
    return http.post(`/apix/agentpc.contract/list.html`,params)
}

// 修改/补充 报价接口
// https://agentpc.sqiquan.cuori.com.cn/apix/agentpc.options/options_supply.html
// 需登录 token
//$bn = input('?post.class')?input('post.class'):'sz0e0001'; 
//$struct = input('?post.struct')?input('post.struct'):'10acall';
//$balance = input('?post.balance')?input('post.balance'):'3o';
//$jobber = input(?post.jobber')?input('post.jobber'):'中信中证';
//$weight = input('?post.weight')?input('post.weight'): 0;
export function optionsSupply(params){
    return http.post(`/apix/agentpc.options/options_supply.html`,params)
}

//当前代理的当天的查询历史。需要登录 传token
// https://agentpc.sqiquan.cuori.com.cn/apix/agentpc.options/search_history.html
export function querySearchHistory(params){
    return http.post(`/apix/agentpc.options/search_history.html`,params)
}



// 有报价券商  https://agentpc.sqiquan.cuori.com.cn/apix/agentpc.options/jobber_valid.html
// $bn = input('?post.bn')?input('post.bn'):'sz000001';// 股票代码
// $struct = input('?post.struct')?input('post.struct'):'100call';// 结构
// $balance = input('?post.balance')?input('post.balance'):'30';// 周期(天),@为不限
export function queryJobberValid(params){
    return http.post(`/apix/agentpc.options/jobber_valid.html`,params)
}


// 热门券商： https://agentpc.sqiquan.cuori.com.cn/apix/agentpc.options/jobber_hot.html
// $rule = input('?post.rule')?input('post.rule'):1;// 最快行权日0-5，a1l所有  t+1传1
// $remark = input('?post.remark')?input('post.remark'):'al1';// 敲出θ不设敲出,a11所有
export function queryJobberHot(params){
    return http.post(`/apix/agentpc.options/jobber_hot.html`,params)
}

// 这个是保存自定义 和 获取 自定义 规则的接口
// https://h5.sqiquan.cuori.com.cn/apix/agentpc.me/jobber_custom.html
// $custom ='中信证券,中信,0,1|招商证券,招商,1,0';
export function queryJobberCustom(params){
    return http.post(`/apix/agentpc.me/jobber_custom.html`,params)
}


// 返回来的分别是 时间、价格，成交量.以这个数据生成之前说的三维图形。
// https://h5.sqiquan.7377.com.cn/apix/h5.hq/list.html
export function queryHqList() {
    return http.post(`/apix/h5.hq/list.html`)
}
